import { constants } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { colors } = constants;

const grey = colors.ui.neutral[500];
const greyExtraLight = colors.ui.neutral[25];

export const rootCss = {
  listStyleType: "none",
  margin: "8px 0",
};

export const buttonCss = (useInactiveStyles, isIrcEnabled) => ({
  alignItems: "center",
  backgroundColor: greyExtraLight,
  borderRadius: "4px",
  opacity: 1 + " !important",
  color: grey,
  display: "flex",
  padding: "8px 8px 8px 16px",
  width: "100%",
  font: "inherit",
  gap: 0,
  ...(isIrcEnabled && { justifyContent: "space-between" }),

  "&:hover": {
    backgroundColor: useInactiveStyles ? greyExtraLight : greyDarkWithOpacity,
  },

  "&[disabled], :hover[disabled]": {
    backgroundColor: greyExtraLight,
    opacity: 1,
  },
});

export const iconCss = {
  height: "32px",
  justifyContent: "center",
  alignSelf: "center",
  padding: "8px 11px",
  width: "32px",

  svg: {
    path: {
      stroke: grey,
    },
  },
};

export const lockIconCss = {
  padding: "4px 5px",
  justifyContent: "center",
  width: "32px",

  svg: {
    path: {
      stroke: grey,
    },
  },
};

export const premiumLabelCss = ({ isIrcEnabled = false }) => ({
  currentColor: grey,
  height: "20px",
  fontSize: "12px",
  justifyContent: "center",
  marginLeft: isIrcEnabled ? "8px" : "auto",
  marginRight: "30px",
  width: "32px",
});
